<template>
  <div class="page">
    <div class="page-content">
      <img class="logo" src="./assets/logo.png" />
      <h3>Succession Resource Group</h3>
      <p>
        Named as one of the top 100 fastest growing private companies in Oregon by Portland Business Journal in 2017 and 2019 and a WealthManagement.com award- winning succession firm, Succession Resource Group, Inc. works with individual financial advisors and RIAs to help them value, improve, protect, grow, and exit their business on their terms.
      </p>
      <p>
        With decades of combined industry experience, SRG possesses a unique combination of skills, resources and expertise to help advisors understand the value of their business, develop strategies to improve that value, protect it with comprehensive contingency and succession plans, and grow through acquisition.
      </p>
      <img class="services" src="./assets/wheel_of_services.svg" />
    </div>

    <BottomColorBar />
  </div>
</template>

<script>
import BottomColorBar from './partials/BottomColorBar'

export default {
  name: 'PdfPage9',
  components: {
    BottomColorBar,
  },
}
</script>

<style scoped>
.page-content {
  display: flex;
  flex-direction: column;

  width: 500px;
  margin: 0 auto;
  padding: 100px 0;
}

.page-content p {
  width: 400px;
  margin: 0 auto 14px;
  text-align: justify;
}
.logo {
  width: 180px;
  margin: 0 auto;
}
.services {
  width: 500px;
  margin: -20px auto 0;
}

h3 {
  margin: 30px 0;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage9.vue